import { render, staticRenderFns } from "./AccordionText.vue?vue&type=template&id=37cd71e2"
import script from "./AccordionText.vue?vue&type=script&lang=js"
export * from "./AccordionText.vue?vue&type=script&lang=js"
import style0 from "./AccordionText.vue?vue&type=style&index=0&id=37cd71e2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports